module.exports = __webpack_public_path__ + "59873955dfa70925df012dca922ab7b4.svg";